import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Leader from '../components/Leader';
import colors from '../assets/colors.js'

const styles = theme => ({
  leaderGrid: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  atGlance: {
    backgroundColor: colors.tealLight,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: 'normal',
    padding: '40px',
  },
});

class Leadership extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <Grid id="about" container justify='center' alignItems='center' spacing={0} align='left'>
        <Grid item xs={12} className={'sectionText gradient'}>
          <Grid container justify='center' alignItems='stretch'>
            <Grid item xs={12} sm={10}>
              <h1 className='white'>Leadership</h1>
              <Grid container className={classes.leaderGrid} alignItems='stretch'>
                <Leader item={{name: 'Reynold M. Sachs', role: 'Chairman', resume: 'Resume_R.Sachs.pdf', linkedIn: ''}} />
                <Leader item={{name: 'Clayton E. Sachs', role: 'Board Member', resume: 'RESUME_CLAYTON_SACHS.pdf', linkedIn: ''}} />
                <Leader item={{name: 'Savannah L. Sachs', role: 'Board Member', resume: 'RESUME_SAVANNAH_SACHS.pdf', linkedIn: ''}} />
                <Leader item={{name: 'Robert M. Long', role: 'Executive Vice President', resume: 'RESUME_RML.pdf', linkedIn: ''}} />
                <Leader item={{name: 'Steven P. Miller', role: 'Certified Public Accountant', resume: '', linkedIn: ''}} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

Leadership.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Leadership);



// WEBPACK FOOTER //
// ./src/views/Leadership.js